import React from 'react'
import "./byEmailList.scss"


import SectionComponent from '../../../../components/utils/SectionComponent'
import { useTranslation } from 'react-i18next'

function ByEmailList() {

  const { t } = useTranslation()

  return (
    <div className='container-by-email-list'>
      <div className="texts-by-email-list">
        <SectionComponent title={t("publish_and_share.email_list.by_email.title")} text={t("publish_and_share.email_list.by_email.section_text")} />
        <SectionComponent title={t("publish_and_share.email_list.intranet.title")} text={t("publish_and_share.email_list.intranet.section_text_1")}>
          <p>{t("publish_and_share.email_list.intranet.section_text_2")}</p>
        </SectionComponent>

        <SectionComponent title={t("publish_and_share.email_list.automatic_reports.title")} text={t("publish_and_share.email_list.automatic_reports.section_text_1")}>
          <br />
          <p>{t("publish_and_share.email_list.automatic_reports.section_text_2")}</p>
        </SectionComponent>
      </div>
    </div>
  )
}

export default ByEmailList